module.exports = {"540328100":"嘎托镇","540328101":"如美镇","540328200":"曲孜卡乡","540328201":"木许乡","540328202":"纳西民族乡","540328203":"朱巴龙乡","540328204":"曲登乡","540328205":"徐中乡","540328206":"帮达乡","540328207":"戈波乡","540328208":"洛尼乡","540328209":"措瓦乡","540328210":"昂多乡","540328211":"宗西乡","540328212":"莽岭乡","540328213":"索多西乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540328.json
// module id = 2517
// module chunks = 0